<template>
  <div class="px-box">
    <img class="px-cover-img" :src="$global.imgUrl + cover" alt="" />
    <div class="px-content">
      <h5 class="px-title" v-html="title"></h5>
      <div class="px-address">
        <div v-if="author">
          <img style="border-radius: 50%" v-if="logo" :src="$global.imgUrl + logo" alt="" />
          <img v-else src="@/assets/img/mobile-img/px-address-icon.png" alt="" />
          <span v-html="author"></span>
        </div>
      </div>
      <div class="px-info">
        <div class="price-box">
          <div class="extend-box" v-if="isExtend">
            <p class="extend-text">
              预计赚¥<span class="extend-span">{{ extendPrice }}</span>
            </p>
            <p class="extend-price">{{ kcPrice }}</p>
          </div>
          <div class="price-text" v-else>{{ kcPrice }}</div>
        </div>
        <div class="isSign">{{ number }}人已报名</div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    price: {
      type: [String, Array],
    },
    author: {
      type: String,
    },
    title: {
      type: String,
    },
    number: {
      type: [String, Number],
      default: 0,
    },
    cover: {
      type: String,
    },
    logo: {
      type: String,
    },
    saleType: {
      type: Number,
      default: 0,
    },
    isExtend: {
      type: Boolean,
      default: false,
    },
    extendPrice: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      searchStr: "",
    };
  },
  computed: {
    kcPrice() {
      if (this.saleType == 1) {
        if (typeof this.price === "string") {
          return "¥" + this.price;
        } else {
          return this.price.length > 1
            ? `¥${this.price[0]}-${this.price[this.price.length - 1]}`
            : "¥" + this.price[0];
        }
      } else {
        return "免费";
      }
    },
    // highLightTitle() {
    //   return this.title.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },

    // highLightAuthor() {
    //   return this.author.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },
    /*
    highLightNumber() {
      return (this.number + "").replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
    */
  },
  created() {
    // this.searchStr = this.$route.query.paramStr;
  },
};
</script>
  
<style scoped lang="scss">
.px-box {
  padding-bottom: 10px;
}
.px-cover-img {
  width: 100%;
  height: 88px;
}
.px-content {
  margin-top: 10px;
  padding: 0 10px;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  // height: 95px;
  .px-title {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .px-address {
    margin: 10px 0 14px;
    min-height: 20px;
    img {
      margin-right: 4px;
      width: 12px;
      height: 12px;
      vertical-align: middle;
    }
    span {
      display: inline-block;
      width: 85%;
      font-size: 12px;
      color: #9c9c9c;
      line-height: 17px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
  }
  .px-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .price-box {
      .extend-box {
        .extend-text {
          font-size: 12px;
          color: #ff3d3d;
          line-height: 17px;
          .extend-span {
            font-weight: 700;
            font-size: 16px;
          }
        }
        .extend-price {
          margin-top: 10px;
          font-size: 12px;
          color: #999999;
          line-height: 17px;
        }
      }
      .price-text {
        flex: 1;
        margin-right: 5px;
        font-size: 15px;
        font-weight: 700;
        color: #ff3d3d;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .isSign {
      flex: 1;
      text-align: right;
      font-size: 11px;
      color: #999999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>